// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EscalatorFault {
  Underspeed = 0,
  SafetyBreak = 1,
  PhaseFailure = 2,
  SmokeDetector = 3,
  KeySwitchStop = 4,
  ConsecutiveStop = 5,
  MotorUnderspeed = 6,
  ExternalShutdown = 7,
  SeismicMonitor = 8,
  Safety = 9,
  Generic = 10,
  CombplateTopLeft = 11,
  HandrailTopLeft = 12,
  SkirtingTop = 13,
  EmergencyStop = 14,
  CombplateBottomLeft = 15,
  HandrailBottomLeft = 16,
  ChaintensionBottom = 17,
  DriveChain = 18,
  HandrailDrop = 19,
  StepUpthrust = 20,
  CombHeating = 21,
  SkirtingBottom = 22,
  Direction = 23,
  BrokenStepBottom = 24,
  StopSwitchTop = 25,
  HandrailStretch = 26,
  StopSwitchBottom = 27,
  FrequencyConverter = 28,
  StopSwitchAuxiliary = 29,
  FloorCoverTop = 30,
  OverspeedTop = 31,
  UnderspeedTop = 32,
  HandrailMonitorLeft = 33,
  HandrailMonitorRight = 34,
  ServiceBrake = 35,
  EmergencyBrake = 36,
  BrokenStepTop = 37,
  SensorInmgb = 38,
  StepAbsenceTop = 39,
  SensorInvkTop = 40,
  StepAbsenceBottom = 41,
  SensorInvkBottom = 42,
  OverspeedBottom = 43,
  UnderspeedBottom = 44,
  SoftStop = 45,
  ParameterLost = 46,
  SreDrop = 47,
  HandrailTopRight = 48,
  HandrailBottomRight = 49,
  CombplateTopRight = 50,
  CombplateBottomRight = 51,
  SafetyCircuit = 52,
  FloorCoverBottom = 53,
  UndefinedStop = 54,
  ContinuousOperation = 55,
  ReadyToStart = 56,
  MotorOnMains = 57,
  AutomaticService = 58,
  EscalatorRunning = 59,
  Down = 60,
  Up = 61,
  TUVSimulation = 62,
  InspectionMode = 63,
  LightCurtainActive = 64,
  ResetMHardware = 65,
  ResetS0Hardware = 66,
  ResetS1Hardware = 67,
  ResetS2Hardware = 68,
  ResetS3Hardware = 69,
  ResetDHardware = 70,
  ResetMBussRetry = 71,
  ResetS0BussRetry = 72,
  ResetS1BussRetry = 73,
  ResetS2BussRetry = 74,
  ResetS3BussRetry = 75,
  ResetDBussRetry = 76,
  ResetMBufferFull = 77,
  ResetS0BufferFull = 78,
  ResetS1BufferFull = 79,
  ResetS2BufferFull = 80,
  ResetS3BufferFull = 81,
  ResetDBufferFull = 82,
  ResetMWrongMess = 83,
  ResetS0WrongMess = 84,
  ResetS1WrongMess = 85,
  ResetS2WrongMess = 86,
  ResetS3WrongMess = 87,
  ResetDWrongMess = 88,
  ResetMMaster = 89,
  ResetS0Master = 90,
  ResetS1Master = 91,
  ResetS2Master = 92,
  ResetS3Master = 93,
  ResetDMaster = 94,
  ResetMTimeOut = 95,
  ResetS0TimeOut = 96,
  ResetS1TimeOut = 97,
  ResetS2TimeOut = 98,
  ResetS3TimeOut = 99,
  ResetDTimeOut = 100,
  ResetMFcom = 101,
  ResetS0Fcom = 102,
  ResetS1Fcom = 103,
  ResetS2Fcom = 104,
  ResetS3Fcom = 105,
  ResetDFcom = 106,
  ResetMSlave = 107,
  VoltageOff = 108,
  SmokeDetectorBottom = 109,
  SkirtingMiddle = 110,
  PhaseControl = 111,
  RubberTop = 112,
  RubberBot = 113,
  BlockingDevice = 114,
  CombHeatingTop = 115,
  StepUpthrustBottom = 116,
  BrakeLining = 117,
  DeviceStopByCustomer = 118,
  DeviceWaterLevelBottom = 119,
  ContactorPickUp = 120
}
